import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'a1-text',
  styleUrl: 'a1-text.scss',
  scoped: true,
})
export class A1Text {
  /**
   * Text content.
   */
  @Prop({ reflect: true }) text!: string;

  /**
   * Text size.
   */
  @Prop({ reflect: true }) size: 'l' | 'm' | 's' = 'm';

  /**
   * Text variant.
   */
  @Prop({ reflect: true }) type: 'primary' | 'secondary' = 'primary';

  /**
   * Toggle for regular / inverted text appearance.
   */
  @Prop({ reflect: true }) inverse: boolean = false;

  render() {
    const classes = {
      [this.size]: true,
      [this.type]: true,
      inverse: this.inverse,
    };

    return (
      <p
        class={Object.keys(classes)
          .filter(key => classes[key])
          .join(' ')}
      >
        {this.text}
      </p>
    );
  }
}
